module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_sbp_logo-30e5fd81b674a9c8cf5b3fb080d2d2a7.png";